import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20.333 3.244H3.667a1.25 1.25 0 0 0-1.25 1.25v11.291a1.217 1.217 0 0 0 1.25 1.209h2.5v3.333a.4.4 0 0 0 .225.367.392.392 0 0 0 .425 0l5.316-3.7h8.2a1.25 1.25 0 0 0 1.25-1.25V4.494a1.25 1.25 0 0 0-1.25-1.25ZM14.5 10.535a1.874 1.874 0 1 1 1.875-1.875v2.1a2.292 2.292 0 0 1-2.292 2.292.625.625 0 0 1 0-1.25 1.042 1.042 0 0 0 1.042-1.042v-.341c-.2.076-.411.115-.625.116Zm-3.125.225a2.292 2.292 0 0 1-2.292 2.292.625.625 0 0 1 0-1.25 1.042 1.042 0 0 0 1.042-1.042v-.341c-.2.076-.411.115-.625.116a1.874 1.874 0 1 1 1.875-1.875v2.1Z",
  fill: "#2C3B4E"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }